// Base
import Image from 'next/image'

// Components
import { Flex, Text } from 'yard-utilities/components'
import Span from '@components/v25/span/Span'

// Icons
import ReviewIcon from '@images/v25/icons/fb-review-icon.svg'
import { GlobeIcon } from 'icons/v25/Icons'

// Styles
import styles from '../FacebookReviewCard.module.sass'

export interface HeaderElementProps {
  avatar: string
  name: string
  reviewPosted: string
}

const HeaderElement = ({ avatar, name, reviewPosted }: HeaderElementProps) => {
  return (
    <Flex columnGap={{ sm: 10 }} spacing={{ sm: 12 }}>
      <Image src={avatar} alt="User's avatar" width={40} height={40} />

      <Flex flexDirection="column">
        <Flex columnGap={{ sm: 8 }} wrap spacing={{ sm: 4 }}>
          <Flex columnGap={{ sm: 4 }}>
            <Text
              tagName="p"
              variant="body-7"
              textColor="black-70"
              fontFamily="segoe"
              fontWeight={600}
              className={styles.usersName}
            >
              {name}
            </Text>
            <Image src={ReviewIcon} alt="Review icon" width={16} height={16} />
          </Flex>

          <Text
            tagName="p"
            variant="body-7"
            textColor="grey-1"
            fontFamily="segoe"
          >
            recommends
          </Text>

          <Text
            tagName="p"
            variant="body-7"
            textColor="black-70"
            fontFamily="segoe"
            fontWeight={600}
          >
            RatePunk
          </Text>
        </Flex>

        <Flex alignItems="center">
          <Text
            tagName="p"
            variant="body-8"
            textColor="grey-1"
            fontFamily="segoe"
          >
            {reviewPosted} &#x2022;&nbsp;
          </Text>
          <GlobeIcon />
        </Flex>
      </Flex>
    </Flex>
  )
}

export default HeaderElement
